import React, { useState } from 'react';
import {
  ProductCardStyle,
  RatingSectionNew,
} from '../../CategoryDetail/L1CategoryPage/ProductCardNew/styled';
import AnchorCoverTag from '../../StoreHomePage/AnchorCoverTag';
import Image from 'next/image';
import { images } from '../../../Constants/ImageUrls';
import AddToCartCta from '../../StoreCategoryPage/SubCategoryProducts/AddToCartCta';
import { useRouter } from 'next/router';
import { queryParamHandling } from '../../../Utils/productPageUtils';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import ProductPriceAB from '../../../Utils/ProductPriceAB';
import { clickCardEvent } from '../../../Utils/StoreHomePageUtils'; // added


function ProductCardHome(props) {
  const { productInfo, store, setChangeCartCount, isAllCategoryPage,section = {}, isParentingPage = false } = props;
  const [activeIndex, setActiveIndex] = useState(null);
  const router = useRouter();
  const callbackFunction = (index, deeplinkValue) => {
    setTimeout(() => {
      const { addParams, newUrl } = queryParamHandling(deeplinkValue);
      router.push(`${newUrl}` + addParams, '', {
        locale: getRouterLocale(router),
      });
    }, [200]);
  };

  const productClickHandler = () => {
    setActiveIndex(productInfo?._id);
     clickCardEvent(productInfo, section, !!isParentingPage);
   
    setTimeout(() => {
      setActiveIndex(null);
    }, 1000);
  };
  return (
    <ProductCardStyle
      isAllCategoryPage={isAllCategoryPage}
      store={store}
      onClick={() => {
        productClickHandler();
      }}
      className={`${activeIndex == productInfo?._id ? 'active' : ''}`}
      extraPadding={true}

      //singleProduct={singleProduct}
    >
      <AnchorCoverTag
        url={productInfo?.webUrl}
        callbackFunction={callbackFunction}
      >
        <div className="imgWrapper">
          {/* {productInfo?.textFlag?.text?.length > 0 && (
                        <ProductFlag flagData={productInfo?.textFlag}>
                            {productInfo?.textFlag?.text}
                            <span></span>
                        </ProductFlag>
                    )} */}

          <Image
            src={productInfo?.image}
            alt=""
            loading="lazy"
            placeholder="blur"
            blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mN88+F3PQAI/wNYdVMfwAAAAABJRU5ErkJggg"
            quality={90}
            fill
            sizes="67vw"
          />
        </div>
        <div className="detailsSection">
          {productInfo?.l2CategoryName ? (
            <p className="category">{productInfo?.l2CategoryName}</p>
          ) : null}

          <p className="productNameNew">{productInfo?.nickname}</p>

          {/* <div className="snippetSection">
                        {productInfo?.productSnipitVariants?.map(
                            (snippet, index) => {
                                return (
                                    <p
                                        key={productInfo?._id + index}
                                        className="snippetText"
                                    >
                                        {snippet?.text}
                                    </p>
                                );
                            },
                        )}
                    </div> */}
          {/* {productInfo?.variantType ? (
                        <div className="variantType">
                            <p>{productInfo?.variantType}</p>
                        </div>
                    ) : null} */}

          <RatingSectionNew store={store} isAllCategoryPage={isAllCategoryPage}>
            <img src={images.newFilledStar} alt="" />
            <p>{productInfo?.starRating}</p>
            <span>{productInfo?.starRatingSubScript}</span>
          </RatingSectionNew>
          {productInfo?.showComboStrip && (
            <div
              className="comboSavingText"
              dangerouslySetInnerHTML={{
                __html: productInfo?.comboSavings + '<span></span>',
              }}
            ></div>
          )}

          {/* <p className="sellingPrice">{productInfo?.price}</p> */}
          <ProductPriceAB
            priceData={productInfo}
            classString="sellingPrice"
            classStringStrike={'strikePrice'}
            classStringDisc={'discount'}
            isAllCategoryPage={isAllCategoryPage}
          />
          {/* {productInfo?.price !== productInfo?.strikePrice ? (
                            <p className="strikePrice">
                                {productInfo?.strikePrice}
                            </p>
                        ) : null}
                        <p className="discount">{productInfo?.discount}</p> */}

          <AddToCartCta
            product={productInfo}
            section={section} //
            category_name={''} //
            setAddedToCart={setChangeCartCount} //
            parentTag={'parentTag'} //
            smallButton={true}
            isCategoryPage={true}
            newUI={true}
            //singleProduct={singleProduct}
          />
        </div>
      </AnchorCoverTag>
    </ProductCardStyle>
  );
}

export default ProductCardHome;
